import React from 'react';
import { Mic, MicOff } from 'lucide-react';

const ParticipantDisplay = ({
  userName, myChannel, isMuted,
  otherParticipant, otherParticipantMuted, isCallConnected
}) => {
  return (
    <div className="flex items-center">
      {/* Current User */}
      <div className="flex items-center gap-2">
        <div className="relative">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-lg">
            <span className="text-lg font-bold text-white">
              {userName.charAt(0).toUpperCase()}
            </span>
          </div>

          {/* String attachment point on left avatar */}
          <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-zinc-500"></div>
        </div>

        <div className="min-w-[80px]">
          <div className="flex items-center gap-1">
            <span className="text-zinc-800 font-medium text-sm">{userName}</span>
            <div className={`p-0.5 rounded ${isMuted ? 'bg-red-500/20' : 'bg-emerald-500/20'}`}>
              {isMuted ? (
                <MicOff className="w-3 h-3 text-red-400" />
              ) : (
                <Mic className="w-3 h-3 text-emerald-400" />
              )}
            </div>
          </div>
          <div className="text-xs text-zinc-600">Channel {myChannel !== null ? myChannel : '?'}</div>
        </div>
      </div>

      {/* Crooked String Connection */}
      {otherParticipant && (
        <>
          <div className="flex-1 mx-2 min-w-[80px] max-w-[100px]">
            <div className="relative h-4">
              {/* Crooked string line - longer and touching edges */}
              <svg
                className="absolute inset-0 w-full h-full"
                viewBox="0 0 100 10"
                preserveAspectRatio="none"
              >
                {/* String path - crooked/curvy */}
               <path
                  d="M0,5 Q25,2 50,7 Q75,3 100,5"
                  fill="none"
                  stroke="#a1a1aa"
                  strokeWidth="1.5"
                  strokeDasharray={isCallConnected ? "none" : "4,4"}
                  className="transition-all duration-300"
                />

                {/* Pulses when communicating and connected */}
                {isCallConnected && !isMuted && (
                  <circle
                    cx="0"
                    cy="5"
                    r="2"
                    fill="#10b981"
                    className="animate-[pulse-travel_1.5s_ease-in-out_infinite]"
                  />
                )}

                {isCallConnected && !otherParticipantMuted && (
                  <circle
                    cx="100"
                    cy="5"
                    r="2"
                    fill="#3b82f6"
                    className="animate-[pulse-travel-reverse_1.5s_ease-in-out_infinite]"
                  />
                )}
              </svg>

              {/* Connection status - minimal */}
              <div className="absolute -bottom-5 left-1/2 transform -translate-x-1/2">
                {isCallConnected ? (
                  <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
                ) : (
                  <span className="w-1.5 h-1.5 rounded-full bg-zinc-600"></span>
                )}
              </div>
            </div>
          </div>

          {/* Other Participant */}
          <div className="flex items-center gap-2">
            <div className="relative">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-rose-500 to-pink-600 flex items-center justify-center shadow-lg">
                <span className="text-lg font-bold text-white">
                  {otherParticipant.name.charAt(0).toUpperCase()}
                </span>
              </div>

              {/* String attachment point on right avatar */}
              <div className="absolute left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-zinc-500"></div>
            </div>

            <div className="min-w-[80px]">
              <div className="flex items-center gap-1">
                <span className="text-zinc-800 font-medium text-sm">{otherParticipant.name}</span>
                <div className={`p-0.5 rounded ${otherParticipantMuted ? 'bg-red-500/20' : 'bg-blue-500/20'}`}>
                  {otherParticipantMuted ? (
                    <MicOff className="w-3 h-3 text-red-400" />
                  ) : isCallConnected ? (
                    <Mic className="w-3 h-3 text-blue-400" />
                  ) : null}
                </div>
              </div>
              <div className="text-xs text-zinc-400">
                Channel {myChannel !== null ? (1 - myChannel) : '?'}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ParticipantDisplay;